import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=4303cdc6&lang=pug&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4303cdc6')) {
      api.createRecord('4303cdc6', component.options)
    } else {
      api.reload('4303cdc6', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=4303cdc6&lang=pug&", function () {
      api.rerender('4303cdc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/Settings.vue"
export default component.exports